import {InputNumber as AntInputNumber, InputNumberProps} from 'antd'

export const InputNumber = (props: InputNumberProps<number> & IInputProps) => {
  return <AntInputNumber {...props} />
}
